import {createApp, defineCustomElement} from "vue";
import ZoekActiviteiten from "./ZoekActiviteiten.vue";
import {createPinia, setActivePinia} from "pinia";
import { setupCalendar } from 'v-calendar';
import VCalendar from 'v-calendar';
import Notifications from '@kyvg/vue3-notification';
import velocity from "velocity-animate";

const pinia = createPinia();

setActivePinia(pinia)

const app = createApp(ZoekActiviteiten);
app.use(pinia);
app.use(setupCalendar, {});
app.use(Notifications, { velocity });

if (document.getElementById('activity-search')) {
app.mount("#activity-search");
}

const element = defineCustomElement(ZoekActiviteiten, {
    shadowRoot: false
});

element.prototype.pinia = pinia;

element.prototype.plugins = [
    { plugin: Notifications },
    { plugin: VCalendar },
  ];

customElements.define('zoek-activiteiten', element);